import * as React from "react";
import { OpenAPI } from "../../../services/openapi";



export const downloadFile =  (id: string, filename: string,) => {
    let url = "" + OpenAPI.BASE + "/doc/getFile/?id=" + id;
    //url = "" + "http://localhost:8008" + "/doc/getFile/?id=" + id
    

    

    fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    })
      // (B) RETURN AS BLOB
      .then((result) => {
        
        if (result.status != 200) {
          throw new Error("Bad server response");
        }
        
        return result.blob();
      })

      // (C) BLOB DATA
      .then((data: Blob | null) => {
        // (C1) FILE DATA IS "READY FOR USE"
        

        // (C2) TO "FORCE DOWNLOAD"
        if (data !== null) {
          var url = URL.createObjectURL(data),
            anchor = document.createElement("a");
          anchor.href = url;
          let saveas = filename ? filename : "Datei.pdf";
          anchor.download = saveas;
          document.body.append(anchor);
          anchor.click();

          // (C3) CLEAN UP
          URL.revokeObjectURL(url);
          document.body.removeChild(anchor);
        }
        data = null

      
      })

      // (D) HANDLE ERRORS - OPTIONAL
      .catch((error) => {
        console.log(error);


      });
  };


export const downloadFolder=(id: string, filename: string) => {
    
    let url = "" + OpenAPI.BASE + "/doc/Files/download?id=" + id;
    //url = "" + "http://localhost:8008" + "/doc/getFile/?id=" + id
    

    

    fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    })
      // (B) RETURN AS BLOB
      .then((result) => {
        
        if (result.status != 200) {
          throw new Error("Bad server response");
        }
        
        return result.blob();
      })

      // (C) BLOB DATA
      .then((data) => {
        // (C1) FILE DATA IS "READY FOR USE"
        

        // (C2) TO "FORCE DOWNLOAD"
        var url = URL.createObjectURL(data),
          anchor = document.createElement("a");
        anchor.href = url;
        let saveas = filename ? (filename + ".zip") : "Ordner.zip";
        anchor.download = saveas;
        document.body.append(anchor);
        anchor.click();

        // (C3) CLEAN UP
        URL.revokeObjectURL(url);
        document.body.removeChild(anchor);

        
      })

      // (D) HANDLE ERRORS - OPTIONAL
      .catch((error) => {
        console.log(error);


       
      });
  };


